import { useState, useEffect } from "react";
import { Card, Tooltip, Zoom, IconButton } from "@mui/material";
import { Delete, Edit, Error } from "@mui/icons-material";
import DashboardLayout from "../../../Layouts/Layoutcontainers";
import EnhancedTable from "../../../components/BTTable";
import BTBox from "../../../components/BTBox";
import BTButton from "../../../components/BTButton";
import authService from "../../../services/auth-service";
import Addconversion from "./Addconversion";
import ConfirmBox from "../../../components/ConfirmBox";
import { useLoading, useNotification } from "../../../context";
import moment from "moment";
import { get_cnv_rates } from "../../../store/functions";
import { useSelector } from "react-redux";
const Conversionrate = () => {
  const conversionRate = useSelector((state) => state?.lab?.conversionRate);
  const [open, setOpen] = useState(null);
  const { showLoading, hideLoading } = useLoading();
  const [isDelete, setDelete] = useState(null);
  const { addNotification } = useNotification();
  const CardHeader = () => {
    return (
      <Card sx={{ mb: 1 }}>
        <BTBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          pt={2}
          pb={2}
          px={3}
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BTButton
            variant="gradient"
            size="small"
            color="dark"
            onClick={() => setOpen({ show: true, actionType: 1 })}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            Add
          </BTButton>
        </BTBox>
      </Card>
    );
  };
  const Actions = ({ row }) => {
    return (
      <BTBox display="flex" flexDirection={"row"} gap={1}>
        <Tooltip title="Edit">
          <Edit
            color="warning"
            sx={{ cursor: "pointer", fontSize: "18px" }}
            onClick={async () => {
              showLoading();
              await new Promise((resolve) => setTimeout(resolve, 1000));
              hideLoading();
              setOpen({
                actionType: 2,
                show: true,
                value: row,
              });
            }}
          />
        </Tooltip>
        <Tooltip title="Edit">
          <Delete
            color="error"
            sx={{ cursor: "pointer", fontSize: "18px" }}
            onClick={async () => {
              setDelete(row);
            }}
          />
        </Tooltip>
      </BTBox>
    );
  };
  const getConversionRate = async () => {
    showLoading();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const response = await get_cnv_rates();
    if (!response?.status) {
      addNotification({
        message: response?.message?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    }
    hideLoading();
  };
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "0.1rem",
      numeric: false,
      sortable: true,
    },
    {
      id: "cnv_date",
      name: "Conversion Date",
      selector: (row) =>
        moment(row?.cnv_date, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY HH:mm:ss"
        ),
      sortable: true,
      numeric: false,
      width: "150px",
    },
    {
      id: "cnv_rate",
      name: "Conversion Rate",
      numeric: false,
      selector: (row) => row?.cnv_rate,
      sortable: false,
      width: "150px",
    },
    {
      id: "cnv_description",
      name: "Description",
      selector: (row) => row?.cnv_description,
      numeric: false,
      sortable: true,
      width: "150px",
    },
    {
      id: "actions",
      name: "Actions",
      selector: (row) => <Actions row={row} />,
      width: "80px",
    },
  ];

  useEffect(() => {
    !conversionRate?.is_fetch && getConversionRate();
  }, []);

  return (
    <DashboardLayout>
      <CardHeader />
      <EnhancedTable
        rows={conversionRate?.data?.filter(({ cnv_deleted }) => !cnv_deleted)}
        columns={columns}
        title="Conversion Rate"
        pagination={true}
      />
      {Boolean(open) && (
        <Addconversion
          open={open}
          setOpen={setOpen}
          conversionRate={conversionRate}
        />
      )}
      {Boolean(isDelete) && (
        <ConfirmBox
          row={isDelete}
          setDelete={setDelete}
          name={"conversionRate"}
          id="cnv_id"
          service={authService?.delete_cnv_rate}
        />
      )}
    </DashboardLayout>
  );
};
export default Conversionrate;
